/* HerSafe cart controller.
   נבנה על ידי bin/build-cart-hersafe-0909.py - אין לערוך ידנית.

   תפקיד יחיד: הסטפר של הכמות בשורת המכשיר מחליף את כל החבילה לטייר
   המתאים, במקום לשנות כמות בלבד. הנימוק המלא, כולל המדידה של החיוב
   ב-513 במקום 388, נמצא בכותרת של סקריפט הבנייה.

   אחרי כל החלפה הקוד קורא שוב את /cart.js ומוודא שני דברים:
     1. אף שורה שנושאת מאפיין gift אינה מחויבת
     2. מספר המכשירים שווה לטייר שביקשנו
   אם אחד מהם נכשל, הוא משחזר את העגלה שהייתה ומודיע. הטבלה משמשת
   לתצוגה בלבד; ההיתר לחיוב מגיע מהבדיקה הזאת ולא מהטבלה. */
(function () {
  'use strict';

  /* הקונפיג נקרא בכל פעם מחדש ולא פעם אחת בטעינה. קריאה חד-פעמית הפילה את
     כל ההגנה: מי שנחת עם עגלה ריקה קיבל סקריפט שיצא מיד, ואז לחיצה על מינוס
     אחרי הוספה חייבה 513 במקום 388. נמדד 09/09. */
  var _cfg = null;
  function CFG() {
    if (_cfg) return _cfg;
    var el = document.getElementById('HsBundleConfig');
    if (!el) return null;
    try {
      var parsed = JSON.parse(el.textContent);
      if (parsed && parsed.tiers) _cfg = parsed;
      return _cfg;
    } catch (e) {
      return null;
    }
  }

  var busy = false;

  /* ------------------------------------------------------------------ */
  /* קונפטי. בלי ספרייה חיצונית ובלי משאב רשת, ולכן הוא מופיע מיד ולא   */
  /* מחכה לכלום. מכבד prefers-reduced-motion.                            */
  /* ------------------------------------------------------------------ */
  function confetti(origin) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (typeof document.createElement('i').animate !== 'function') return;

    var wrap = document.createElement('div');
    wrap.className = 'hs-confetti';
    wrap.setAttribute('aria-hidden', 'true');
    document.body.appendChild(wrap);

    var colors = ['#9755e1', '#c9a4f2', '#ffd166', '#ffffff', '#7b3fc4'];
    var n = 34;
    for (var i = 0; i < n; i++) {
      var p = document.createElement('i');
      p.style.background = colors[i % colors.length];
      p.style.left = origin.x + 'px';
      p.style.top = origin.y + 'px';
      wrap.appendChild(p);

      var ang = (Math.PI * 2 * i) / n + (Math.random() - 0.5) * 0.5;
      var dist = 60 + Math.random() * 110;
      var dx = Math.cos(ang) * dist;
      var dy = Math.sin(ang) * dist - 40 - Math.random() * 50;
      var rot = (Math.random() - 0.5) * 720;
      var dur = 750 + Math.random() * 500;

      p.animate(
        [
          { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
          { transform: 'translate(' + dx + 'px,' + (dy + 90) + 'px) rotate(' + rot + 'deg)', opacity: 0 }
        ],
        { duration: dur, easing: 'cubic-bezier(.15,.7,.4,1)', fill: 'forwards' }
      );
    }
    setTimeout(function () {
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    }, 1500);
  }

  /* ------------------------------------------------------------------ */
  /* עגלה                                                                */
  /* ------------------------------------------------------------------ */
  function getCart() {
    return fetch(window.Shopify && window.Shopify.routes ? '/cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function props(item) {
    var raw = (item.properties || {})['__kaching_bundles'];
    if (!raw) return {};
    try { return JSON.parse(raw); } catch (e) { return {}; }
  }

  function deviceUnits(cart) {
    return cart.items.reduce(function (a, i) {
      var c = CFG();
      return c && i.variant_id === c.main ? a + i.quantity : a;
    }, 0);
  }

  /* ההיתר לחיוב: אף מתנה אינה מחויבת, ומספר המכשירים הוא מה שביקשנו. */
  function verify(cart, tier) {
    var charged = cart.items.filter(function (i) {
      return props(i).gift && i.final_line_price > 0;
    });
    if (charged.length) {
      return 'שורות מתנה חויבו: ' + charged.map(function (i) { return i.product_title; }).join(', ');
    }
    if (deviceUnits(cart) !== tier) {
      return 'מספר המכשירים ' + deviceUnits(cart) + ' ואמור להיות ' + tier;
    }
    return null;
  }

  /* HSM-ARMB-CART START */
  /* בזרוע B המתנה היא המוצר עצמו: שתי שורות של אותו וריאנט, אחת בתשלום
     ואחת עם אסימון gift. המבנה והאסימונים נמדדו מ-/cart.js אמיתי 13/09
     ולא נוחשו. bid, gift, v ו-abid מגיעים מהקונפיג, לא מהקוד. */
  function hsArmBPayload(tier) {
    var c = CFG(), ab = hsArmBCfg();
    var t = ab && ab.tiers[String(tier)];
    if (!c || !t) return null;
    var gid = String(Date.now()) + String(Math.floor(Math.random() * 1e6));
    var wrap = function (o) { return { __kaching_bundles: JSON.stringify(o) }; };
    var items = [{
      id: c.main,
      quantity: t.paid,
      properties: wrap({ deal: c.deal, pp: c.pp, main: true, v: ab.v,
                         id: gid, bid: t.bid, abid: ab.abid, ab: ab.ab })
    }];
    if (t.free) {
      items.push({
        id: c.main,
        quantity: t.free,
        properties: wrap({ id: gid, deal: c.deal, v: ab.v, abid: ab.abid,
                           ab: ab.ab, gift: t.gift })
      });
    }
    return items;
  }
  /* HSM-ARMB-CART END */
  /* HSM-ARMB-CART START */
  /* שתי הבדיקות הקיימות לא תופסות bid חוצה-זרועות שמחזיר ספירת מכשירים
     תקינה בלי ההנחה, ולכן נוספת כאן בדיקת סכום מול הטבלה. */
  var hsPayloadBase = null, hsVerifyBase = null;
  function hsArmBVerify(cart, tier) {
    var ab = hsArmBCfg(), t = ab && ab.tiers[String(tier)];
    if (!t) return 'אין טבלת דרגות להצעה הזאת';
    var charged = cart.items.filter(function (i) {
      return props(i).gift && i.final_line_price > 0;
    });
    if (charged.length) {
      return 'שורות מתנה חויבו: ' + charged.map(function (i) { return i.product_title; }).join(', ');
    }
    var want = (t.paid || 0) + (t.free || 0);
    if (deviceUnits(cart) !== want) {
      return 'מספר המכשירים ' + deviceUnits(cart) + ' ואמור להיות ' + want;
    }
    if (cart.total_price !== t.total) {
      return 'הסכום ' + (cart.total_price / 100) + ' ואמור להיות ' + (t.total / 100);
    }
    return null;
  }
  /* HSM-ARMB-CART END */
  function payload(tier) {
    var c = CFG();
    if (!c) return null;
    var t = c.tiers[String(tier)];
    if (!t) return null;
    var gid = String(Date.now()) + String(Math.floor(Math.random() * 1e6));
    var wrap = function (o) { return { __kaching_bundles: JSON.stringify(o) }; };
    var items = [{
      id: c.main,
      quantity: tier,
      properties: wrap({ deal: c.deal, pp: c.pp, main: true, v: c.v, id: gid, bid: t.bid })
    }];
    t.gifts.forEach(function (g) {
      items.push({
        id: g.id,
        quantity: tier,
        properties: wrap({ id: gid, deal: c.deal, v: c.v, gift: g.gift })
      });
    });
    return items;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, body: j }; });
    });
  }

  /* משחזר בדיוק את השורות שהיו, כולל המאפיינים, אחרי בדיקה שנכשלה */
  function restore(snapshot) {
    return post('/cart/clear.js', {}).then(function () {
      var items = snapshot.items.map(function (i) {
        return { id: i.variant_id, quantity: i.quantity, properties: i.properties || {} };
      });
      if (!items.length) return null;
      return post('/cart/add.js', { items: items });
    });
  }

  function refresh() {
    var drawerItems = document.querySelector('cart-drawer-items');
    var pageItems = document.querySelector('cart-items');
    var host = drawerItems || pageItems;
    var done = host && typeof host.onCartUpdate === 'function'
      ? host.onCartUpdate()
      : Promise.resolve();
    return Promise.resolve(done).then(function () {
      /* הבועה של האייקון בהאדר לא נכללת ב-onCartUpdate של המגירה */
      return fetch('/?section_id=cart-icon-bubble')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('.shopify-section');
          var dst = document.getElementById('cart-icon-bubble');
          if (src && dst) dst.innerHTML = src.innerHTML;
        })
        .catch(function () {});
    }).then(markSingle);
  }

  function fail(msg) {
    console.error('[hersafe-cart] ' + msg);
    var box = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
    /* HSM-ARMB-COPY START */
    if (box) {
      box.textContent = 'לא הצלחנו לעדכן את ההזמנה. אפשר לבחור אותה מחדש בדף המוצר.';
      return;
    }
    /* HSM-ARMB-COPY END */
    if (box) box.textContent = 'לא הצלחנו לעדכן את הערכה. אפשר לבחור אותה מחדש בדף המוצר.';
  }

  /* ------------------------------------------------------------------ */
  /* החלפת טייר                                                          */
  /* ------------------------------------------------------------------ */
  /* HSM-ARMB-GUARD START */
  /* זרוע B של ה-A/B מזוהה מתוכן העגלה ולא מהזרוע עצמה, ולכן היא נכונה גם
     לעגלה שנבנתה בשני ביקורים ולעגלה שהגיעה מקישור ישיר. */
  var hsArmB = false;
  function hsArmBCfg() {
    var c = CFG();
    return (c && c.armB && c.armB.tiers) ? c.armB : null;
  }
  function hsArmBCart() {
    /* עדות מהעגלה גוברת: שורת מוצר ראשי במחיר 0 קיימת רק בזרוע B. */
    if (document.querySelector('[data-hs-gift-main]')) return true;
    /* במכשיר בודד אין עדיין מתנה ושתי הזרועות נראות זהות בעגלה, ולכן
       נשענים על הזרוע שהמסכה רשמה בדף המוצר. שובר שוויון בלבד. */
    try { if (localStorage.getItem('hsArm') === 'B') return true; } catch (e) {}
    return false;
  }
  /* HSM-ARMB-GUARD END */
  /* HSM-ARMB-CART START */
  hsPayloadBase = payload;
  payload = function (tier) {
    return hsArmB ? hsArmBPayload(tier) : hsPayloadBase(tier);
  };
  hsVerifyBase = verify;
  verify = function (cart, tier) {
    return hsArmB ? hsArmBVerify(cart, tier) : hsVerifyBase(cart, tier);
  };
  /* HSM-ARMB-CART END */
  function swap(tier, row) {
    if (busy) return;
    var c = CFG();
    if (!c) return;
    /* HSM-ARMB-GUARD START */
    /* ההחלטה נקבעת פעם אחת בכניסה ל-swap. אחרי clear+add ה-DOM עדיין מראה
       את המצב הקודם, ולכן בדיקה חוזרת באמצע הריצה הייתה עונה על עגלה ישנה. */
    hsArmB = hsArmBCart();
    if (hsArmB) {
      var hsAb = hsArmBCfg();
      /* בלי טבלה לזרוע B אין מטען שאפשר להצדיק. עדיף סטפר שלא זז
         מאשר חיוב לפי דרגה של הזרוע השנייה. */
      if (!hsAb) return;
      tier = Math.max(1, Math.min(hsAb.maxTier, tier));
    }
    /* HSM-ARMB-GUARD END */
    tier = Math.max(1, Math.min(c.maxTier, tier));
    var items = payload(tier);
    if (!items) return;

    busy = true;
    if (row) row.classList.add('hs-line--busy');

    var snapshot = null;
    getCart()
      .then(function (c) {
        snapshot = c;
        return post('/cart/clear.js', {});
      })
      .then(function () {
        return post('/cart/add.js', { items: items });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('add.js ' + JSON.stringify(res.body));
        return getCart();
      })
      .then(function (after) {
        var why = verify(after, tier);
        if (why) {
          return restore(snapshot).then(function () {
            throw new Error(why);
          });
        }
        return null;
      })
      .catch(function (e) {
        fail(e && e.message ? e.message : String(e));
      })
      .then(function () {
        return refresh();
      })
      .then(function () {
        busy = false;
        if (row) row.classList.remove('hs-line--busy');
      });
  }

  /* ------------------------------------------------------------------ */
  /* יירוט                                                               */
  /* ------------------------------------------------------------------ */
  function currentTier(row) {
    var input = row.querySelector('.quantity__input');
    return input ? parseInt(input.value, 10) || 0 : 0;
  }

  /* בשלב ה-capture, לפני המאזין ש-QuantityInput רושם על הכפתור עצמו.
     stopImmediatePropagation מונע מ-Dawn לשנות כמות בצורה נאיבית. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.quantity__button') : null;
    if (!btn) return;
    var row = btn.closest('[data-hs-bundle-main]');
    if (!row) return;
    var c = CFG();
    if (!c) return;

    var name = btn.getAttribute('name');
    if (name !== 'plus' && name !== 'minus') return;

    var now = currentTier(row);
    var next = name === 'plus' ? now + 1 : now - 1;

    /* ירידה מתחת ל-1 היא הסרה רגילה ואין בה מתנות להפסיד. משאירים ל-Dawn. */
    if (next < 1) return;
    /* מעל הערכה הגדולה ביותר אין בר בקאצ'ינג, ולכן אין לאן לעלות. */
    if (next > c.maxTier) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    if (next === now) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (name === 'plus') {
      var r = btn.getBoundingClientRect();
      confetti({ x: r.left + r.width / 2, y: r.top + r.height / 2 });
    }
    swap(next, row);
  }, true);

  /* הקלדה ישירה בשדה הכמות עוברת באותו מסלול */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('quantity__input')) return;
    var row = input.closest ? input.closest('[data-hs-bundle-main]') : null;
    if (!row) return;
    var want = parseInt(input.value, 10);
    if (!want || want < 1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    swap(want, row);
  }, true);

  /* ------------------------------------------------------------------ */
  /* רוקני את הסל                                                        */
  /* ------------------------------------------------------------------ */
  /* אישור בשתי לחיצות. הלחיצה הראשונה דורכת את הכפתור ומחליפה את התווית,
     והשנייה מבצעת. לחיצה במקום אחר, מקש Escape או חמש שניות מחזירים אותו
     למצב רגיל. אין כאן חלון confirm של הדפדפן במכוון: הוא נראה זר לאתר,
     ובחלק מהדפדפנים הוא נחסם. */
  var armedBtn = null;
  var armTimer = null;

  function disarm() {
    if (!armedBtn) return;
    var lbl = armedBtn.querySelector('span');
    if (lbl && armedBtn.getAttribute('data-hs-label') !== null) {
      lbl.textContent = armedBtn.getAttribute('data-hs-label');
    }
    armedBtn.classList.remove('hs-empty-cart--armed');
    armedBtn = null;
    clearTimeout(armTimer);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-hs-empty-cart]') : null;
    if (!btn) {
      disarm();
      return;
    }
    e.preventDefault();
    if (busy) return;

    if (armedBtn !== btn) {
      disarm();
      var lbl = btn.querySelector('span');
      if (lbl) {
        btn.setAttribute('data-hs-label', lbl.textContent);
        lbl.textContent = 'בטוחה? לחצי שוב';
      }
      btn.classList.add('hs-empty-cart--armed');
      armedBtn = btn;
      armTimer = setTimeout(disarm, 5000);
      return;
    }

    disarm();
    busy = true;
    btn.setAttribute('aria-busy', 'true');

    post('/cart/clear.js', {})
      .then(function () {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.close === 'function') {
          /* סוגרים קודם ומרעננים מאחורי המגירה הסגורה, אחרת
             נראית לרגע עגלה ריקה לפני שהיא נסגרת. */
          drawer.close();
          return refresh();
        }
        /* בדף העגלה אין מה לסגור, והחלפת innerHTML לבדה משאירה
           את מצב העגלה הריקה של Dawn לא מעודכן. טעינה מחדש. */
        window.location.reload();
        return null;
      })
      .catch(function (err) {
        fail(err && err.message ? err.message : String(err));
      })
      .then(function () {
        busy = false;
        btn.removeAttribute('aria-busy');
      });
  });

  /* ------------------------------------------------------------------ */
  /* מצב "מכשיר אחד" - מפעיל את הפעימה על הפלוס                          */
  /* ------------------------------------------------------------------ */
  /* HSM-ARMB-COPY START */
  /* hs-armb על html הוא מה שמחליף את הקופי בעגלה. נגזר מתוכן העגלה,
     ולכן נכון גם לעגלה שנבנתה בשני ביקורים ולקישור ישיר. */
  function markArm() {
    var b = hsArmBCart();
    document.documentElement.classList.toggle('hs-armb', b);
    var tr = document.querySelector('.hs-bar__track[aria-label]');
    if (tr && b && CFG_ARMB_ARIA) tr.setAttribute('aria-label', CFG_ARMB_ARIA);
  }
  var CFG_ARMB_ARIA = 'ההתקדמות למכשיר שמתווסף בחינם';
  /* HSM-ARMB-COPY END */
  function markSingle() {
    var row = document.querySelector('[data-hs-bundle-main]');
    var single = !!row && currentTier(row) === 1;
    document.documentElement.classList.toggle('hs-cart--single', single);
    /* HSM-ARMB-COPY START */
    markArm();
    /* HSM-ARMB-COPY END */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markSingle);
  } else {
    markSingle();
  }
  document.addEventListener('cart:refresh', markSingle);
  /* HSM-PULSE START */
  /* אף קובץ בערכה לא יורה cart:refresh, ו-Dawn מעדכנת עגלה דרך pub/sub
     (assets/pubsub.js, סקריפט קלאסי ולכן subscribe גלובלי). בלי שתי החוליות
     האלה markSingle רץ פעם אחת בטעינה ואז אף פעם, והפעימה לא מופיעה למי
     שנחת עם עגלה ריקה והוסיף מכשיר. נמדד 13/09. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, markSingle);
  }

  /* רשת ביטחון: רינדור סקשנים של Dawn מחליף את ה-DOM של המגירה, ולא כל
     מסלול מפרסם cartUpdate. markSingle משנה מחלקה על html בלבד ולכן אינו
     מפעיל את הצופה הזה מחדש. */
  if (typeof MutationObserver === 'function') {
    var hsPulseQueued = false;
    new MutationObserver(function (muts) {
      if (hsPulseQueued) return;
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.closest && t.closest('cart-drawer, cart-drawer-items, cart-items, #CartDrawer, #main-cart-items')) {
          hsPulseQueued = true;
          requestAnimationFrame(function () { hsPulseQueued = false; markSingle(); });
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  /* HSM-PULSE END */

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') disarm();
  });
})();
